import type { SwidgeProviderName } from '@infinex/actions';

import OneinchFusionIconPath from './assets/providers/1inch-fusion-logo.svg';
import OneinchIconPath from './assets/providers/1inch-logo.svg';
import AcrossIconPath from './assets/providers/across-logo.svg';
import BebopIconPath from './assets/providers/bebop-logo.svg';
import BluefinIconPath from './assets/providers/bluefin-logo.svg';
import CowswapIconPath from './assets/providers/cowswap-logo.svg';
import DebridgeIconPath from './assets/providers/debridge-logo.svg';
import DflowIconPath from './assets/providers/dflow-logo.svg';
import EnsoIconPath from './assets/providers/enso-logo.svg';
import GasZipIconPath from './assets/providers/gas-zip-logo.svg';
import HoudiniIconPath from './assets/providers/houdini-logo.svg';
import JupiterIconPath from './assets/providers/jupiter-logo.svg';
import KyberswapIconPath from './assets/providers/kyberswap-logo.svg';
import LifiIconPath from './assets/providers/lifi-logo.svg';
import MayanIconPath from './assets/providers/mayan-logo.svg';
import NearIntentsIconPath from './assets/providers/near-intents-logo.svg';
import OkxIconPath from './assets/providers/okx-logo.svg';
import OogaboogaIconPath from './assets/providers/oogabooga-logo.svg';
import PythIconPath from './assets/providers/pyth-logo.svg';
import RelayIconPath from './assets/providers/relay-logo.svg';
import RenegadeIconPath from './assets/providers/renegade-logo.svg';
import StargateIconPath from './assets/providers/stargate-logo.svg';
import TitanIconPath from './assets/providers/titan-logo.svg';
import UniswapIconPath from './assets/providers/uniswap-logo.svg';
import ValiantIconPath from './assets/providers/valiant-logo.svg';
import XswapIconPath from './assets/providers/xswap-logo.svg';

export const PRICE_IMPACT_BPS_THRESHOLDS = {
  NORMAL: 0,
  MEDIUM: 150, // >= 1.5%
  HIGH: 500, // >= 5%
} as const;

export const FEE_BPS_THRESHOLDS = {
  NORMAL: 0,
  MEDIUM: 0.25, // >= $0.25
  HIGH: 2, // >= $2
} as const;

/**
 * Provider icons mapping
 */
export const PROVIDER_ICONS = {
  mayan: MayanIconPath,
  lifi: LifiIconPath,
  relay: RelayIconPath,
  jupiter: JupiterIconPath,
  '1inch': OneinchIconPath,
  '1inchFusion': OneinchFusionIconPath,
  enso: EnsoIconPath,
  bebop: BebopIconPath,
  bluefin: BluefinIconPath,
  uniswap: UniswapIconPath,
  cowswap: CowswapIconPath,
  stargate: StargateIconPath,
  nearIntents: NearIntentsIconPath, // TODO: @MIN deprecate in fast follow
  oneClickNearIntents: NearIntentsIconPath,
  debridge: DebridgeIconPath,
  oogabooga: OogaboogaIconPath,
  jupiterZ: JupiterIconPath,
  pyth: PythIconPath,
  pythViaJupiter: PythIconPath,
  across: AcrossIconPath,
  xswap: XswapIconPath,
  renegade: RenegadeIconPath,
  okx: OkxIconPath,
  gaszip: GasZipIconPath,
  kyberswap: KyberswapIconPath,
  titan: TitanIconPath,
  dflow: DflowIconPath,
  valiant: ValiantIconPath,
  houdini: HoudiniIconPath,
} satisfies Record<SwidgeProviderName, string>;

/**
 * Human-readable provider names
 */
export const PROVIDER_DISPLAY_NAMES: Record<SwidgeProviderName, string> = {
  mayan: 'Mayan',
  lifi: 'Li.Fi',
  relay: 'Relay',
  jupiter: 'Jupiter',
  '1inch': '1inch',
  '1inchFusion': '1inch Fusion',
  enso: 'Enso',
  bebop: 'Bebop',
  bluefin: 'Bluefin',
  uniswap: 'Uniswap',
  cowswap: 'Cowswap',
  stargate: 'Stargate',
  nearIntents: 'Near Intents', // TODO: @MIN deprecate in fast follow
  oneClickNearIntents: 'Near Intents',
  debridge: 'deBridge',
  oogabooga: 'Oogabooga',
  jupiterZ: 'JupiterZ',
  pyth: 'Pyth Express Relay',
  pythViaJupiter: 'Pyth Express Relay (Via Jupiter)',
  across: 'Across',
  xswap: 'XSwap',
  renegade: 'Renegade',
  okx: 'Okx',
  gaszip: 'Gas.zip',
  kyberswap: 'KyberSwap',
  titan: 'Titan',
  dflow: 'DFlow',
  valiant: 'Valiant',
  houdini: 'Houdini',
};

/**
 * Helper to get both icon and display name for a provider
 */
export function getProviderDisplayInfo(providerName: SwidgeProviderName) {
  return {
    icon: PROVIDER_ICONS[providerName],
    displayName: PROVIDER_DISPLAY_NAMES[providerName],
  };
}
